import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Button} from "primeng/button";
import {FormsModule} from "@angular/forms";
import {Select} from "primeng/select";
import {NotificationService} from "../../services/notification.service";
import {ApartmentService} from "../../services/apartment.service";
import {MessageService} from "primeng/api";
import {Router} from "@angular/router";
import {finalize, map, of, tap, Observable} from "rxjs";
import {SubmitButtonComponent} from "../../components/submit-button/submit-button.component";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-command-for-users-page',
  standalone: true,
  imports: [CommonModule, FormsModule, SubmitButtonComponent, Button, Select],
  templateUrl: './command-for-users-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommandForUsersPageComponent {
  protected loading = signal(false);
  protected selectedLotteryId = signal<string | undefined>(undefined);
  private readonly notificationService = inject(NotificationService);
  private readonly apartmentService = inject(ApartmentService);
  private readonly messageService = inject(MessageService);
  private readonly router = inject(Router);

  protected readonly openLotteries = toSignal(
    this.apartmentService.apartments$.pipe(
      map(apartments => apartments.filter(a => a.status === 'open'))
    ),
    {initialValue: []}
  );

  protected trigger: () => Observable<unknown> = () => {
    const lotteryId = this.selectedLotteryId();
    if (!lotteryId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No lottery selected',
        detail: 'Please select a lottery first.'
      });
      return of(undefined);
    }

    this.loading.set(true);
    return this.notificationService.triggerCommandForUsers('full-new-eligible-lotteries', lotteryId).pipe(
      tap({
        next: (result) => this.messageService.add({
          severity: 'success',
          summary: 'Queued',
          detail: `Queued ${result.count} signup users for new-eligible-lotteries processing.`
        }),
        error: () => this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Could not trigger command-for-users.'
        })
      }),
      finalize(() => this.loading.set(false))
    );
  }

  protected goBack() {
    this.router.navigate(['/users']);
  }
}
